import { requestService as api } from "./Request.service";

/* ============================================================
   บริการเรียก API ของ AK-HOME — ทุก resource ใช้รูปแบบเดียวกัน
     GET  manage.php            รายการ (ส่ง params เป็น query)
     GET  manage.php?code=      รายละเอียด
     POST / PUT / PATCH         บันทึก (คืน { status, data })
     DELETE manage.php?code=    ปิดการใช้งาน / ยกเลิก
============================================================ */
const crud = (base) => ({
  list: (params = {}, config = {}) => api.get(`${base}/manage.php`, { params, ...config }),
  get: (code, config = {}) => api.get(`${base}/manage.php`, { params: { code }, ...config }),
  create: (body) => api.post(`${base}/manage.php`, body),
  update: (body) => api.put(`${base}/manage.php`, body),
  patch: (body) => api.patch(`${base}/manage.php`, body),
  remove: (code) => api.delete(`${base}/manage.php`, { params: { code } }),
});

export const CustomerService = crud("/customer");
export const HouseModelService = crud("/house-model");
export const MaterialCategoryService = crud("/material-category");
export const MaterialService = crud("/material");
export const TemplateService = crud("/template");
export const EmployeeService = crud("/employee");
export const ProjectService = crud("/project");
export const SelectionService = crud("/selection");

/* อัปโหลดรูป type = material | house_model | employee → { path } */
export const uploadImage = (file, type) => {
  const fd = new FormData();
  fd.append("type", type);
  fd.append("file", file);
  return api.post(`/common/upload.php`, fd, { ignoreLoading: true });
};

/* ข้อความ error จาก API (status 0 + message) */
export const apiError = (err, fallback = "เกิดข้อผิดพลาด") =>
  err?.response?.data?.message || err?.message || fallback;

/* ---------- Login ลูกค้า (portal) ---------- */
export const CustomerPortalService = {
  get: (code) => api.get(`/customer/portal.php`, { params: { code }, ignoreLoading: true }),
  /* สร้าง / รีเซ็ตรหัสผ่าน → data.password (แสดงครั้งเดียว) */
  reset: (cus_code, username) => api.post(`/customer/portal.php`, { cus_code, username: username || undefined }),
  setActive: (cus_code, active) => api.patch(`/customer/portal.php`, { cus_code, active }),
};

/* ---------- ไฟล์แนบโปรเจ็กต์ / แบบบ้าน ---------- */
const toForm = (fields, files) => {
  const fd = new FormData();
  Object.entries(fields).forEach(([k, v]) => v !== undefined && v !== null && fd.append(k, v));
  (files || []).forEach((f) => fd.append("files[]", f.originFileObj || f));
  return fd;
};

export const ProjectFileService = {
  list: (project) => api.get(`/project/file.php`, { params: { project }, ignoreLoading: true }),
  upload: (fields, files) => api.post(`/project/file.php`, toForm(fields, files)),
  patch: (body) => api.patch(`/project/file.php`, body, { ignoreLoading: true }),
  remove: (id) => api.delete(`/project/file.php`, { params: { id } }),
  blob: (id, inline) => api.get(`/project/file.php`, { params: { id, inline: inline ? 1 : undefined }, responseType: "blob" }),
};

/* ---------- RC ---------- */
export const RcService = {
  list: (params = {}, config = {}) => api.get(`/rc/manage.php`, { params, ...config }),
  get: (code) => api.get(`/rc/manage.php`, { params: { code } }),
  /* แจ้งแทนลูกค้า: { project_code, rc_type, title, detail } */
  create: (fields, files) => api.post(`/rc/manage.php`, toForm(fields, files)),
  /* เพิ่มข้อความ/ไฟล์ในเรื่องเดิม: { rc_code, note } */
  addNote: (fields, files) => api.post(`/rc/manage.php`, toForm(fields, files)),
  /* { rc_code, status?, note?, cost_change? } */
  update: (body) => api.patch(`/rc/manage.php`, body),
  blob: (id, inline) => api.get(`/rc/manage.php`, { params: { file: id, inline: inline ? 1 : undefined }, responseType: "blob" }),
};

export { toForm as toFormData };
